export enum Gender {
    M = 'm',
    V = 'v'
}

export interface Klant {
    bank: Bank;
    familienaam: string;
    tussenvoegsel?: string;
    voornamen: string;
    voorletters: string;
    geboorte_datum: string;
    geslacht: Gender;
    emailadres: string;
    telefoonnummer: string;
    nederlands_adres: NederlandsAdres;
}

export interface NederlandsAdres {
    straat: string;
    huisnummer: number;
    huisnummer_toevoeging?: string;
    postcode: string;
    plaats: string;
}

export enum Bank {
    ASN = 'asn',
    SNS = 'sns',
    RGB = 'rgb'
}
